import '../css/Home.css'
import ArticleLeftItem from "../components/items/ArticleLeftItem";
import ArticleRightItem from "../components/items/ArticleRightItem";
import doctorUsingMobilePhone from '../people/Rectangle 52.png'
import doctorsTalking from '../people/doctors_talking.mp4'
import doctorsTalkingPic from '../people/doctors_talking.png'
import nursesUsingMobilePhone from '../people/Rectangle 51.png'
import doctorUsingTablet from '../people/doctor-using-tablet.png'
import PatientEdItem from "../components/items/PatientEdItem";
import analysis from '../people/analysis.png'
import securityEnsured from '../people/man-security.png'
import doctorTypingBig from '../people/doctor-typing.png'
import xraySkull from '../people/xray.png'
import ProductArticle from "../components/items/ProductArticle";
import womanUsingPhone from "../people/Rectangle 51 (1).png"
import BlogPost from "../components/items/BlogPost";
import LearnMoreDialogBox from "../components/sectioning/LearnMoreDialogBox";
import FAQList from "../components/sectioning/FAQList";
import { motion } from 'framer-motion'
import { useRef, useState } from 'react';

function Home() {
    const [isPlaying, setIsPlaying] = useState(true)
    const videoRef = useRef()

    let pauseVideo = () => {
        videoRef.current.pause()
        setIsPlaying(false)
    }

    let playVideo = () => {
        videoRef.current.play()
        setIsPlaying(true)
    }

    return (
        <>
          <motion.main 
            id="home"
            initial={{width: 0}}
            animate={{width: '100%'}}
            exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
          >
            <section className="intro">
                <p>Where AI and EHR unite for smarter healthcare</p>
                <button className="trynow">Schedule a demo</button>
                <div>
                    <video loop ref={videoRef} muted autoPlay={true} playsInline={true} src={doctorsTalking} >
                    </video>
                    <img src={doctorsTalkingPic} alt="three doctors having a conversation while standing" />
                    {isPlaying ? 
                    <button onClick={pauseVideo} title="Pause Video"><i className="fa-solid fa-pause"></i></button> :
                    <button onClick={playVideo} title='Play Video'><i className="fa-solid fa-play"></i></button>}
                </div>
            </section>
            <ArticleLeftItem 
                pill_text="We offer" 
                article_heading="Healthcare for All" 
                article_text="MedBolt bridges the gap between patients and providers. Our mission is to make healthcare accessible, personalized, and efficient for everyone, everywhere." 
                article_img={doctorUsingMobilePhone}
                alt="medical doctor using a mobile phone"
                amountShown={['some', 'some']}
            />
            <ArticleRightItem 
                pill_text="Join the Revolution"
                article_heading="Paper to Digital Transformation"
                article_text="Witness the transformation from paper to digital records. MedBolt paves the way for a sustainable healthcare future, reducing waste and inefficiencies."
                article_img={doctorTypingBig}
                img_alt_text="doctor using typing with a stethoscope on the table"
            />
            <ArticleLeftItem
                pill_text="Customizability"
                article_heading="Tailored to Your Needs"
                article_text="MedBolt understands that healthcare varies from person to person. Our platform allows for customization, ensuring that both healthcare providers and individuals can adapt MedBolt to their unique requirements."
                article_img={nursesUsingMobilePhone}
                img_alt_text="nurses using a mobile phone"
            />
            <ArticleRightItem
                pill_text="Intuitive User Interface"
                article_heading="Seamless and User-Friendly"
                article_text="MedBolt's intuitive interface simplifies healthcare management for patients and healthcare providers alike. Say goodbye to paperwork and hello to effortless digital health records."
                article_img={doctorUsingTablet}
                img_alt_text="doctor using tablet with a stethoscope on the table"
            />
            <section className="patients">
                <p className="pill_text">Everywhere you go</p>
                <h1>Experience a New Era in Healthcare Access</h1>
                <p className="article_text">MedBolt ensures your complete medical history is securely accessible by any healthcare institution, anytime, anywhere. No more worrying about lost records or redundant tests.</p>
                <ul className="patient-ed-list">
                    <PatientEdItem
                        heading="Seeing Beyond the Surface"
                        ed_text="Discover the power of predictive and descriptive analytics. MedBolt's AI offers healthcare providers data-backed insights, so they can offer proactive care, while patients can stay informed about their health."
                        image={xraySkull}
                        delay={0.3}
                    />
                    <PatientEdItem 
                        heading="Streamlining Your Workflow"
                        ed_text="MedBolt takes the hassle out of record-keeping for healthcare providers. Our AI handles data management, allowing you to focus on what matters most – patient care."
                        image={analysis}
                        delay={0.2}
                    />
                    <PatientEdItem 
                        heading="Your Data, Your Privacy"
                        ed_text="At MedBolt, security is our top priority. We employ state-of-the-art encryption and data protection measures to safeguard your health information. Your privacy matters, and we're committed to keeping your data safe."
                        image={securityEnsured}
                    />
                </ul>
            </section>
            <ProductArticle 
                    article_heading="Your Health, Your Way"
                    summary="Our advanced AI tailors treatments to your unique needs. MedBolt empowers you to take control of your health journey with personalized recommendations and real-time guidance."
                    article_img={womanUsingPhone} 
                />
            <section className="blog">
                    <p className="pill_text">Blog</p>
                    <h1>Your health records always with you</h1>
                    <p>Say goodbye to the stress of requesting medical records and waiting for weeks. With a few clicks, you can access all your medical history whenever you need it.</p>
                    <ul className="blogposts">
                        <BlogPost 
                            heading="Impact of AI in the healthcare sector"
                            author="Habeeb Lawal"
                            date_posted="13th May, 2023"
                            summary="Impact of AI in the healthcare sector. We could see that from the advent of technology in the year 1990 that the invention of machine learning and artificial intelligence"
                        />
                        <BlogPost 
                            heading="Impact of AI in the healthcare sector"
                            author="Habeeb Lawal"
                            date_posted="13th May, 2023"
                            summary="Impact of AI in the healthcare sector. We could see that from the advent of technology in the year 1990 that the invention of machine learning and artificial intelligence"
                        />
                        <BlogPost 
                            heading="Impact of AI in the healthcare sector"
                            author="Habeeb Lawal"
                            date_posted="13th May, 2023"
                            summary="Impact of AI in the healthcare sector. We could see that from the advent of technology in the year 1990 that the invention of machine learning and artificial intelligence"
                        />
                    </ul>
            </section>
            <LearnMoreDialogBox/>
            <section className="faqs">
                <div>
                    <h1>FAQs</h1>
                </div>
                <FAQList/>
            </section>
          </motion.main>
        </>
    );
}

export default Home